
/** Tüketim Özeti'nde kullanıcıya görünecek enerji tipleri  */
export enum EnergyTypeEnum {

  /** Elektrik */
  Electrical = 1,

  /** Su */
  Water = 2,

  /** Doğalgaz */
  Gas = 3,

  /** Sıcaklık  */
  Heat = 4,

  /** Diğer */
  Other = 5,

  /** LPG */
  LPG = 6,

  /** Benzin  */
  Gasoline = 7,

  /** Tümü */
  All = 8,

  /** Motorin  */
  Diesel = 9,

  /** Taş Kömürü */
  MineralCoal = 10,

  /** Kok Kömürü */
  CokeCoal = 11,

  /** Odun */
  Wood = 12,

  FuelOilNo4 = 13,

  FuelOilNo5 = 14,

  FuelOilNo6 = 15,

  /** Propan */
  Propane = 16,

  /** Asetilen */
  Acetylene = 17
}

/** tüketim tipleri */
export enum ConsumptionTypeEnum {
  Imwh = 1,
  Vah = 2,
  El_Wh = 3,
  El_VArh = 4,
  El_VAh = 5,
  El_J = 6,

  /** Su m3 */
  Water_m3 = 7,

  /** Su litre */
  Water_lt = 8,

  /** 1 US Fluid Gallon * 0.0037854117891320312  = Cubic Meter */
  Water_gal = 9,

  /** 1 Cubic Foot(ft3) * 0.0283168466 = Cubic Meter */
  Water_ft3 = 10,

  /** Gaz m3 */
  Gas_m3 = 11,

  /** Gas Foot (ft3) */
  Gas_ft3 = 12,

  /** 1 * 0.527889 = Wh */
  Heat_Wh = 13,

  /** 1 * 0.293 Wh */
  Heat_BTU = 14,

  /** ton birim */
  Ton = 15,

  /** LPG Ton birim */
  LPG_Ton = 16,

  /** LPG Gas_m3 birim */
  LPG_Gas_m3 = 17,

  /** Gasoline Ton birim */
  Gasoline_Ton = 18,

  /** Diesel Ton birim */
  Diesel_Ton = 19,

  /** MineralCoal Ton birim */
  MineralCoal_Ton = 20,

  /** CokeCoal Ton birim */
  CokeCoal_Ton = 21,

  /** Wood Ton birim */
  Wood_Ton = 22,

  /** FuelOilNo4 Ton birim */
  FuelOilNo4_Ton = 23,

  /** FuelOilNo5 Ton birim */
  FuelOilNo5_Ton = 24,

  /** FuelOilNo6 Ton birim */
  FuelOilNo6_Ton = 25,

  /** Propane Gas_m3 birim */
  Propane_Gas_m3 = 26,

  /** Acetylene Gas_m3 birim */
  Acetylene_Gas_m3 = 27,

  /** TL gösterim */
  Price = 100,

  /**
   * TEP gösterim
   * Tüm enerji birimleri TEP olarak gösterilir
   */
  TEP = 90,

  /**
   * Ayrı ayrı gösterim
   * Her bir enerji birimi gösterilir
   */
  Individual = 95

}

/** Tüketim Özeti'nde kullanıcının seçeceği tarih tipleri  */
export enum DateModeType {

  /** Saat */
  Hour = 0,

  /** Gün */
  Day = 1,

  /** Hafta */
  Week = 2,

  /** Ay */
  Month = 3,

  /** Sene (Haftalık) */
  YearWeekly = 4,

  /** Sene (Aylık) */
  YearMonthly = 5
}

/** Tesis Kaynakları */
export enum FacilityResourceLocation {
  /** Ana pano */
  Facility = 0,

  /** Kat */
  Floor = 1,

  /** Bölüm */
  Section = 2,

  /** Yük */
  Resource = 3,
}

/** Tüketim Gruplaması */
export enum ConsumptionGrouping {
  /** Kat */
  Floor = 1,

  /** Bölüm */
  Section = 2,

  /** Yük */
  Resource = 3,

  /** Ürün */
  // Product = 4 -- release yapıldıktan sonra açılacaktır.
}

/** Tarih modu seçimine göre akıllı karşılaştırma tercihleri */
export enum SmartComparison {
  /**
   * Önceki Hafta Aynı Gün.
   * Referans grafikte bir önceki haftanın aynı haftaiçi gününün saatleri gelir.
   */
  PreviousWeekSameDay = 1,

  /**
   * Önceki Sene Aynı Gün.
   * Referans grafikte bir önceki senenin aynı haftasının aynı haftaiçi gününün saatleri gelir.
   * Örn sarı grafikte 2019 Temmuz 1 Pzt, sarı grafikte 2018 temmuz 2 pzt saatleri gelir.
   */
  PreviousYearSameDay = 2,

  /**
   * Birer Gün Öncesi.
   * Referans grafikte birer gün önceler gelir. Örn sarı grafikte 2019 Temmuz 4 gri grafikte 2019 Temmuz 3 vardır (1 gün öncesi)
   */
  ADayAgo = 3,

  /**
   * Önceki Ay.
   * Referans grafikte bir önceki ayın günleri gelir ama bu günler pzt, salı... vs denk gelecek şekilde kaydırılır.
   * Ayın 1. pazartesileri üst üste gelmelidir.
   * Örn sarı grafikte 2019 Temmuz 1 Pzt, gri grafikte 2019 Haziran 3 pzt gelmelidir
   */
  PreviousMonth = 4,

  /**
   * Önceki Sene Aynı Ay
   * Referans grafikte bir önceki senenin aynı ayının günleri gelir ama bu günler pzt, salı... denk gelecek şekilde kaydırılır.
   * Örn sarı grafikte 2019 Temmuz 1 Pzt, sarı grafikte 2018 temmuz 2 pzt gelir.
   */
  PreviousYearSameMonth = 5,

  /**
   * Birer Ay Öncesi.
   * Referans grafikte birer ay önceler gelir. Örn sarı grafikte 2019 şubat gri grafikte 2019 ocak vardır (1 ay öncesi)
   */
  AMonthAgo = 6,

  /**
   * Önceki Sene.
   * Referans grafikte bir önceki senenin ayları çakışacak şekilde gösterim yapılır. Örn sarı grafikte 2019 ocak, gri grafikte 2018 ocak vardır.
   */
  PreviousYear = 7,

  /**
   * Birer Hafta Öncesi.
   * Referans grafikte bir önceki haftanın günleri gelir önceler gelir. Örn sarı grafikte 2019 12.hafta günleri, gri grafikte 2019 11.hafta günleri vardır (1 hafta öncesi)
   */
  AWeekAgo = 8,

  /**
   * Önceki Sene Aynı Hafta.
   * Referans grafikte bir önceki sene aynı haftanın günleri çakışacak şekilde gösterim yapılır. Örn sarı grafikte 2019 12.hafta günleri, gri grafikte 2018 12.hafta günleri vardır.
   */
  PreviousYearSameWeek = 9,

  /**
   * Sene (Haftalık) Birer Hafta Öncesi.
   * Örk sarı grafikte 2019 1-52 hafta , gri grafikte 2018 1-51 hafta verileri gelecek.
   */
  AWeekAgoYear = 10,

  /**
   * Sene (Haftalık) Önceki Sene
   * Örk sarı grafikte 2019 1 - 52 hafta , gri grafikte 2018 1-52 hafta verileri gelecek.
   */
  PreviousWeekOfYear = 11
}
